/* ------ List-Grid view on collection page  ------  */

function replaceUrlParam(url, paramName, paramValue) {
    var pattern = new RegExp('('+paramName+'=).*?(&|$)'),
        newUrl = url.replace(pattern,'$1' + paramValue + '$2');
    if ( newUrl == url ) {
      newUrl = newUrl + (newUrl.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
    }
    return newUrl;
  }

$(function ($) { 
  
    $('.change-view').on('click', function() {
      
      var view = $(this).data('view'),
          url = document.URL,
          hasParams = url.indexOf('?') > -1;

      if (hasParams) {
        window.location = replaceUrlParam(url, 'view', view);
      } else {
        window.location = url + '?view=' + view;
      }
    });
  
  
});

/* ------ List-Grid view on collection page  end ------  */


/* mobile view filter: popup */

$(function () {
  $('.popup-modal').magnificPopup({
    type: 'inline',
    preloader: false,    
    modal: true
  });
  $(document).on('click', '.popup-modal-dismiss', function (e) {
    e.preventDefault();
    $.magnificPopup.close();
  });
});
  
/* /mobile view filter: popup */

$(function ($) {

    /*---------------- Filter Toggle ------------------*/
    if ($(window).width() < 767) {

        /*---------------- Responsive Menu ------------------*/
        $(".nav-trigger").on('click', function (e) {
            $("body").toggleClass('off-canvas-body');
            $(".menu-bar").toggleClass("off-canvas");
            e.preventDefault();
        });
        $('.menu-bar .dropdown-toggle > span').on("click", function (e) {
            $(this).parent('.dropdown-toggle').next('.dropdown-menu').slideToggle(600);
            $(this).toggleClass('ion-ios-arrow-down ion-ios-arrow-up');
            e.stopPropagation();
            e.preventDefault();
        });
       
    }
  
 


    /*---------------- Shop Slider ------------------*/
  
  $('.shop-slider-nav').slick({
   
    dots: false,
    infinite: true,
    prevArrow: false,
    nextArrow: false,
    vertical: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    verticalSwiping: true,
    responsive: [
      {
        breakpoint: 421,
        settings: {
          vertical: false,
          slidesToShow: 4,
          slidesToScroll: 1
        }
      }
    ]    
    
  });
  
   
  /*---------------- Main Slider ------------------*/
  $('.popup-video').magnificPopup({
    disableOn: 200,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false,
    gallery: {
      enabled: true,
      navigateByImgClick: true,
      preload: [0, 1] // Will preload 0 - before current, and 1 after the current image
    }
  });
  
  
  /* keep stay open selected sidebar content*/

  $(".sidebar-wrap .sidebar-content .title").each(function () {
    $(this).removeClass('open');
  });
  $(".sidebar-wrap .active").each(function () {    
    $(this).closest('.sidebar-content').children('.sidebar-content .title').addClass('open');
    $(this).closest('.sidebar-content').children('.inner-content').css({'display':'block'});
  });
  
  /* /keep stay open selected sidebar content*/
  
  
    /*---------------- Equal Height Div on collection page for products------------------*/

  var maxHeight = 0;

  $(".prod-wrap .prod-title").each(function () {
    if ($(this).height() > maxHeight) {
      maxHeight = $(this).height();      
    }
  });

  $(".prod-wrap .prod-title").height(maxHeight);
  
  
  
});